import script from "./SimpleResourceManagement.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimpleResourceManagement.vue?vue&type=script&setup=true&lang=ts"

import "./SimpleResourceManagement.vue?vue&type=style&index=0&id=1c4574fc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c4574fc"]])

export default __exports__